/* eslint-disable react/display-name */
'use client';

import React from 'react';

import { DateCellType } from './date.types';
import Backdrop from '../Backdrop/Backdrop';
import Calendar from './Calendar';

interface DatePickerProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  date?: Date;
  setDate: (date: Date) => void;
}
const DatePicker = React.forwardRef<HTMLDivElement, DatePickerProps>((props, ref) => {
  const { visible, setVisible, date, setDate } = props;

  const handleDateChange = (e: DateCellType) => {
    setDate(new Date(e.timeStamp));
    setVisible(false);
  };

  return visible ? (
    <div style={{ position: 'relative' }}>
      <Backdrop setVisible={setVisible} visible={visible} isTransparent={true} />
      <Calendar ref={ref} startDate={date} handleDateChange={handleDateChange} />
    </div>
  ) : null;
});

export default DatePicker;
